import React from 'react'
import { connect } from 'react-redux'
import {setAttributi} from '../redux'
import moreVerticalIcon from './menu.svg'
import CloseIcon from '@material-ui/icons/Close';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListaAttributi from './ListaAttributi'
// import L from "leaflet";
// import axios from 'axios'

// String.prototype.insert = function(index, string) {
//     if (index > 0) {
//       return this.substring(0, index) + string + this.substr(index);
//     }
  
//     return string + this;
//   };

function TabellaAttributi (props){
// function callCapabilities(url) {
//     var defaultParameters = {
//         version: '1.1.0',
//         request: 'GetCapabilities',
//     };
//     var parameters = L.Util.extend(defaultParameters);
//     var URL = url + L.Util.getParamString(parameters);
    
    
//     axios.get(URL)
//     .then(response => {
//         const paths = response.data
        
//     })

//     .catch( error => {
//         const errorMsg = error.message    
//     })
// }

    // try {
        
    //     var url = props.attributi.attributi.value.serviceUrl
    //     if (url !== undefined){
    //         let len = url.lastIndexOf('/') + 1
    //         url = url.insert(len,`${props.attributi.attributi.value.name}/`)
    //         callCapabilities(url)
    //     }else {
    //     url = props.attributi.attributi.value.element.serviceUrl
    //     callCapabilities(url)
    //     }
        
        
    // } catch (error) {

    // }


const [anchorEl, setAnchorEl] = React.useState(null);
const handleClose = () =>{
    props.setAttributi({state:false,value:''})
}
const handleCloseMenu = ()=>{
    setAnchorEl(null);
}
const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
const functionOne = () =>{
    setAnchorEl(null);
}
const functionTwo = () =>{
    setAnchorEl(null);
}
const functionThree = () =>{
    setAnchorEl(null);
}
    return(<div className={"tabellaAttributi"}>
        <div className={"attributiTitleDiv"}>
            <button className={"moreVerticalButton"} onClick={handleClick}><img style={{width: '22px',height: '22px'}} src={moreVerticalIcon} alt="more"></img></button>
            <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
          <MenuItem onClick={functionOne}>Filtra</MenuItem>
          <MenuItem onClick={functionTwo}>Cancella</MenuItem>
          <MenuItem onClick={functionThree}>Export CSV</MenuItem>
      </Menu>
            <button className={"closeAttributiButton"} onClick={handleClose}><CloseIcon style={{color:'white'}}/></button>
        </div>
        <div className={"attributiList"}>
            <ListaAttributi data={props}/>
        </div>
    </div>)


}
const mapStateToProps = state => {
    return {
        attributi: state.attributi
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      setAttributi: (attributi) =>dispatch(setAttributi(attributi))
    }
}
export default connect(mapStateToProps,mapDispatchToProps) (TabellaAttributi)